/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * @module MentalHealthIcon
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';

/**
 * Represents a Mental Health icon element.
 *
 * @param {object} props - The component prop object.
 * @param {string} [props.color] - The color to apply to the icon (Default: '#000000').
 *
 * @returns {React.ReactElement} The Mental Health Icon element.
 */
export default function MentalHealthIcon({ color = '#000000' }) {
  return (
    <div className="icon" data-color={color} data-testid="mental-health-icon">
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.70312 6.75C8.97813 6.75 8.35938 6.49375 7.84688 5.98125C7.33438 5.46875 7.07812 4.85 7.07812 4.125C7.07812 3.4 7.33438 2.78125 7.84688 2.26875C8.35938 1.75625 8.97813 1.5 9.70312 1.5C10.4281 1.5 11.0469 1.75625 11.5594 2.26875C12.0719 2.78125 12.3281 3.4 12.3281 4.125C12.3281 4.85 12.0719 5.46875 11.5594 5.98125C11.0469 6.49375 10.4281 6.75 9.70312 6.75ZM9.70312 5.25C10.0156 5.25 10.2813 5.14063 10.5 4.92188C10.7188 4.70313 10.8281 4.4375 10.8281 4.125C10.8281 3.8125 10.7188 3.54688 10.5 3.32813C10.2813 3.10938 10.0156 3 9.70312 3C9.39062 3 9.125 3.10938 8.90625 3.32813C8.6875 3.54688 8.57812 3.8125 8.57812 4.125C8.57812 4.4375 8.6875 4.70313 8.90625 4.92188C9.125 5.14063 9.39062 5.25 9.70312 5.25ZM8.63438 15.4313L5.20312 12C4.95312 11.75 4.76562 11.4688 4.64062 11.1562C4.51562 10.8438 4.45312 10.5 4.45312 10.125C4.45312 9.3875 4.70625 8.76562 5.2125 8.25938C5.71875 7.75313 6.34063 7.5 7.07812 7.5C7.44062 7.5 7.775 7.56875 8.08125 7.70625C8.3875 7.84375 8.66563 8.0375 8.91563 8.2875L9.70312 9.075L10.4906 8.2875C10.7406 8.0375 11.0188 7.84375 11.325 7.70625C11.6313 7.56875 11.9656 7.5 12.3281 7.5C13.0656 7.5 13.6875 7.75313 14.1938 8.25938C14.7 8.76562 14.9531 9.3875 14.9531 10.125C14.9531 10.5 14.8906 10.8438 14.7656 11.1562C14.6406 11.4688 14.4531 11.75 14.2031 12L10.7719 15.4313C10.6219 15.5813 10.4531 15.6938 10.2656 15.7688C10.0781 15.8438 9.89062 15.8813 9.70312 15.8813C9.51562 15.8813 9.32812 15.8438 9.14062 15.7688C8.95312 15.6938 8.78438 15.5813 8.63438 15.4313ZM9.70312 14.3625L13.1156 10.95C13.2281 10.8375 13.3125 10.7094 13.3688 10.5656C13.425 10.4219 13.4531 10.275 13.4531 10.125C13.4531 9.825 13.3469 9.5625 13.1344 9.3375C12.9219 9.1125 12.6531 9 12.3281 9C12.1781 9 12.0438 9.02188 11.925 9.06563C11.8063 9.10938 11.6906 9.1875 11.5781 9.3L9.70312 11.175L7.82813 9.3C7.75313 9.225 7.65625 9.15625 7.5375 9.09375C7.41875 9.03125 7.26562 9 7.07812 9C6.75312 9 6.48438 9.1125 6.27188 9.3375C6.05938 9.5625 5.95312 9.825 5.95312 10.125C5.95312 10.275 5.98438 10.4156 6.04688 10.5469C6.10938 10.6781 6.19063 10.8 6.29063 10.9125L9.70312 14.3625Z"
          fill={color}
        />
        <path
          d="M8.20312 8.5H6.20312L5.70312 10.5L7.20312 13.5L10.2031 15L11.7031 13.5L14.2031 10.5L13.2031 8.5H12.2031L9.70312 10L8.20312 8.5Z"
          fill={color}
        />
        <circle cx="9.70312" cy="4" r="2" fill={color} />
      </svg>
    </div>
  );
}
